import { Pagination } from "@/common/components/pagination";
import { H3 } from "@/common/elements";
import { KeyValueObj } from "@/common/types";

interface IRecallDistributors {
  data: KeyValueObj[];
  showResponse?: boolean;
}

const DistributorDetails = ({ data, showResponse }: IRecallDistributors) => {
  return (
    <div className="distributorWrapper">
      <H3>Affected Distributors ({data?.length || 0})</H3>
      {data?.length > 0 ? (
        <>
          <div className="distributorContainer">
            {data?.map((dist, index) => (
              <div key={index}>
                <div
                  style={{
                    gridTemplateColumns: showResponse
                      ? "repeat(3, 1fr)"
                      : "repeat(2, 1fr)",
                  }}
                  className="distibutorItem"
                >
                  <h3>{dist.name}</h3>
                  <span>{dist.value} Cartons</span>
                  {showResponse && (
                    <div className={`status ${dist.response}`}>
                      <h3>{dist.response}</h3>
                    </div>
                  )}
                </div>
                <div className="separate"></div>
              </div>
            ))}
          </div>
          <div className="paginationWrapper">
            <div className="paginationController">
              <Pagination
                onNextPage={() => console.log("next requested")} //just for testing, to be removed
                onPerPageChange={() => console.log("per page change")} //just for testing, to be removed
                pageCount={2}
                dontShowLabel={true}
              />
            </div>
          </div>
        </>
      ) : (
        <h5>No distributors provided</h5>
      )}
    </div>
  );
};

export default DistributorDetails;
